/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssetManagementCreateDto } from '../../models/asset-management-create-dto';
import { AssetManagementItem } from '../../models/asset-management-item';
import { BaseResponse } from '../../models/base-response';

export interface AssetManagementControllerCreate$Params {
      body: AssetManagementCreateDto
}

export function assetManagementControllerCreate(http: HttpClient, rootUrl: string, params: AssetManagementControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
  const rb = new RequestBuilder(rootUrl, assetManagementControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AssetManagementItem;
      }>;
    })
  );
}

assetManagementControllerCreate.PATH = '/asset-management';
